<div style="background-color: #fff;" (click)="onScriptLoad()">
  @if (loading) {
  <div>
    <div class="overlay"></div>
    <div class="loader text-center"><img src="../theme/images/kudoshub-loader.gif" alt="loader"></div>
  </div>
  }
  @if (popupComponentLoaded) {
  <div>
    <ng-container *ngComponentOutlet="popupComponent"></ng-container>
  </div>
  }
  <!-- <app-offer-popup *ngIf="showOfferPopup" (valueUpdate)="getShowOfferPopupValue($event)"></app-offer-popup> -->
  <app-toaster-container></app-toaster-container>
  <router-outlet #outlet="outlet"></router-outlet>
</div>